module.exports = __webpack_public_path__ + "img/57.10585ed4.jpg";